// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__ZzB2Y","colMaxWidth":"Table_colMaxWidth__3lcFg"};